'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _actions = require('../actions');

var _FileListView = require('../components/Browser/Files/FileListView.jsx');

var _FileListView2 = _interopRequireDefault(_FileListView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return state.folders;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    addFiles: function addFiles(files) {
      dispatch((0, _actions.addFiles)(files));
    },
    onClose: function onClose() {
      dispatch((0, _actions.closeFolder)(ownProps.folder));
    }
  };
};

var FolderList = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FileListView2.default);

exports.default = FolderList;


//////////////////
// WEBPACK FOOTER
// ./client/containers/fileList.js
// module id = 78
// module chunks = 0